import React, { useEffect, useState } from "react";
import Slider from "react-slick";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import img0 from "../Images/Videos/0.png";

function CenterMode() {
  const [videos, setVideos] = useState([
    {
      url: "https://www.youtube.com/embed/m9YPUvEPQrI",
      img: img0,
      titulo: "Aire",
      texto: "Ganador del Premio 2025",
      open: true,
    },
    {
      url: "https://www.youtube.com/embed/9Gx6hwprXog",
      img: img0,
      titulo: "Industrias Magaña",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/r61gvkehcg8",
      img: img0,
      titulo: "AMOTLAZOLLI",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/oENK3j9mwJ4",
      img: img0,
      titulo: "CSMX",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/lFA1HUxlYXU",
      img: img0,
      titulo: "ANDRES",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/hXbJZfeXVg0",
      img: img0,
      titulo: "CEMGI",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/X_hwn_wFVZk",
      img: img0,
      titulo: "Biól. Héctor de Alba",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/sfWlD8K_j60",
      img: img0,
      titulo: "La Cuadra Provoca Ciudad A.C.",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/9h11aJWxAes",
      img: img0,
      titulo: "Reciclajes Talismán",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/r3n6DQq0_rA",
      img: img0,
      titulo: "Municipio de San Luis Potosí",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/Om0HZtTyJ0Q",
      img: img0,
      titulo: "Municipio de Sahuayo, Michoacán",
      texto: "Ganador del Premio 2025",
      open: false,
    },
    {
      url: "https://www.youtube.com/embed/mmvFDC52dzw",
      img: img0,
      titulo: "SIAP",
      texto: "Ganador del Premio 2025",
      open: false,
    }
  ]);

  useEffect(() => {
    const handleResize = () => {
      setSettings((prevSettings) => ({
        ...prevSettings,
        slidesToShow: window.innerWidth <= 768 ? 1 : 3,
      }));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [settings, setSettings] = useState({
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "50px",
    slidesToShow: 3,
    speed: 500,
    dots: true,
    slidesToScroll: 1,
    afterChange: (index) => handleSlideChange(index),
  });

  const handleSlideChange = (currentIndex) => {
    setVideos(prevVideos => 
      prevVideos.map((video, index) => ({
        ...video,
        open: index === currentIndex
      }))
    );
  };

  return (
    <>
      <Slider {...settings}>
        {videos.map((video, index) => (
          <div key={index}>
            <div className="container-slider">
              {!video.open ? (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "56.25%", /* 16:9 ratio (9/16 * 100) */
                    overflow: "hidden",
                    filter: "opacity(.9)",
                  }}
                >
                  <img
                    alt="Videos Premiados"
                    src={video.img}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain", // Para imágenes más grandes
                      objectPosition: "center", // Centra la imagen
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      background: "#515151",
                      width: "96px",
                      height: "96px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      zIndex: 2, // Asegura que esté por encima de la imagen
                    }}
                  >
                    <PlayArrowIcon style={{ fontSize: "80px" }} />
                  </div>
                </div>
              ) : (
                <div className="video-container">
                  <iframe
                    src={video.url}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
              <p className="titulo-video">{video.titulo}</p>
              <p className="texto-video">{video.texto}</p>
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
}

export default CenterMode;
